"use client";

import { c as _c } from "react/compiler-runtime";
import { BiTransfer } from "react-icons/bi";
import { useMemo } from "react";
import { usePaymentMethods } from "@context/payment-methods-context";
import MoneyClient from "../../../../components/MoneyClient";
import { normalizeCurrency, toCents } from "@lib/currency";
import { STORE_BASE_CURRENCY } from "@lib/config";
export default function ProductPrice(t0) {
  const $ = _c(26);
  const {
    product
  } = t0;
  const originalPrice = typeof product?.originalPrice === "number" ? product.originalPrice : typeof product?.price === "number" ? product.price : 0;
  const discountedPrice = typeof product?.discountedPrice === "number" ? product.discountedPrice : null;
  const hasDiscount = discountedPrice !== null && discountedPrice > 0 && discountedPrice < originalPrice;
  const finalPrice = hasDiscount ? discountedPrice : originalPrice;
  let t1;
  if ($[0] !== finalPrice || $[1] !== hasDiscount || $[2] !== originalPrice) {
    t1 = hasDiscount ? Math.round((1 - finalPrice / originalPrice) * 100) : undefined;
    $[0] = finalPrice;
    $[1] = hasDiscount;
    $[2] = originalPrice;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const computedPercent = t1;
  const displayPercent = typeof product?.discount === "number" && product.discount > 0 ? product.discount : computedPercent;
  const {
    wire
  } = usePaymentMethods();
  const t2 = typeof product?.currency === "string" ? product.currency : STORE_BASE_CURRENCY;
  let t3;
  if ($[4] !== t2) {
    t3 = normalizeCurrency(t2, STORE_BASE_CURRENCY);
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const productCurrency = t3;
  let t4;
  bb0: {
    if (wire && wire.enabled && wire.discountActive && wire.discountPercent > 0) {
      const percent = wire.discountPercent;
      const price = finalPrice * (1 - percent / 100);
      let t5;
      if ($[6] !== percent || $[7] !== price) {
        t5 = {
          showTransferPrice: true,
          transferPrice: price,
          transferPercent: percent
        };
        $[6] = percent;
        $[7] = price;
        $[8] = t5;
      } else {
        t5 = $[8];
      }
      t4 = t5;
      break bb0;
    }
    let t5;
    if ($[9] !== finalPrice) {
      t5 = {
        showTransferPrice: false,
        transferPrice: finalPrice,
        transferPercent: 0
      };
      $[9] = finalPrice;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    t4 = t5;
  }
  const {
    showTransferPrice,
    transferPrice,
    transferPercent
  } = t4;
  if (!finalPrice) {
    let t5;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="block h-9 w-32 animate-pulse bg-gray-100" />;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    return t5;
  }
  let t5;
  if ($[12] !== displayPercent || $[13] !== finalPrice || $[14] !== hasDiscount || $[15] !== originalPrice || $[16] !== productCurrency) {
    t5 = hasDiscount ? <div className="flex flex-col gap-2"><div className="flex items-center gap-3"><span className="text-lg font-lealti-light text-gray-500 line-through"><MoneyClient amountCents={toCents(originalPrice)} fromCurrency={productCurrency} /></span>{displayPercent ? <div className="flex h-[35px] w-[62px] items-center justify-center bg-lanamara text-[10px] font-semibold uppercase tracking-wide text-white">{displayPercent}% OFF</div> : null}</div><span className="text-3xl font-lealti-light text-black"><MoneyClient amountCents={toCents(finalPrice)} fromCurrency={productCurrency} /></span></div> : <span className="text-3xl font-lealti-light text-black"><MoneyClient amountCents={toCents(finalPrice)} fromCurrency={productCurrency} /></span>;
    $[12] = displayPercent;
    $[13] = finalPrice;
    $[14] = hasDiscount;
    $[15] = originalPrice;
    $[16] = productCurrency;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== productCurrency || $[19] !== showTransferPrice || $[20] !== transferPercent || $[21] !== transferPrice) {
    t6 = showTransferPrice && <div className="flex items-center gap-x-2"><div className="flex items-center gap-x-2 rounded-3xl border border-black p-1 bg-black text-white"><BiTransfer className="h-4 w-4 " /><span className="text-[9px] font-lealti-light tracking-[0.05em] ">TRANSFERENCIA</span></div><span className="text-lg font-lealti-light text-black"><MoneyClient amountCents={toCents(transferPrice)} fromCurrency={productCurrency} /></span>{transferPercent > 0 && <span className="text-[11px] font-lealti-light text-emerald-700">{transferPercent}% OFF</span>}</div>;
    $[18] = productCurrency;
    $[19] = showTransferPrice;
    $[20] = transferPercent;
    $[21] = transferPrice;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== t5 || $[24] !== t6) {
    t7 = <div className="flex w-full flex-col gap-3">{t5}{t6}</div>;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  return t7;
}